import { render } from "./elem-upload.vue?vue&type=template&id=1df69056&ts=true"
import script from "./elem-upload.vue?vue&type=script&lang=ts"
export * from "./elem-upload.vue?vue&type=script&lang=ts"

import "./elem-upload.vue?vue&type=style&index=0&id=1df69056&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__